<template>
	<b-card class="text-left upload-image-container mt-0">
		<!-- :class="{ 'p-0': showAssetIcon }" -->
		<label class="upload-label"
			>{{ text }}<span v-show="isMandatory" class="asterik">*</span></label
		>
		<b-skeleton v-if="showLoader" :height="loaderHeight"></b-skeleton>
		<template v-else>
			<div v-show="error" class="fc-red fw-500 fs-11 my-1 font-primary">
				File Required
			</div>
			<div
				class="upload-dot-cont position-relative gap-0"
				:class="{ 'file-error': error }"
				@drop.prevent="handleFileDrop"
			>
				<template v-if="!showAssetIcon">
					<span class="cin-black-txt d-flex align-items-center pb-1"
						><img class="mr-3" src="@/assets/common/upload.svg" alt="" /> Drag &
						Drop or <span class="cin-blue-txt">&nbsp;Browse file</span></span
					>
					<span class="cin-black-txt-2">OR</span>

					<span
						class="cin-black-txt d-flex align-items-center pointer"
						style="z-index: 200"
						@click.stop="$emit('open-assets')"
						><img class="mr-3" src="@/assets/common/upload.svg" alt="" />Add
						from <span class="cin-blue-txt">&nbsp;Assets Library</span></span
					>

					<span v-if="description" class="cin-grey-txt pt-2"
						>Cover Size should be 600x400. Maximum <br />
						Image Size should be 20MB</span
					>
					<div class="cin-grey-txt" v-if="description">(PNG, JPG,JPEG)</div>
					<span v-if="videoDescription" class="cin-grey-txt pt-2"
						>Maximum Video Size should be 5GB</span
					>
					<span v-if="previewVideoDescription" class="cin-grey-txt pt-2"
						>Maximum Video Size should be 2GB</span
					>
					<div
						class="cin-grey-txt"
						v-if="videoDescription || previewVideoDescription"
					>
						(MP4,WEBM,MOV)
					</div>
				</template>
				<template v-else>
					<h2
						class="black-txt cin-black-txt d-flex align-items-center flex-column"
					>
						<img
							class="mr-3 mb-3"
							src="@/assets/common/upload-cloud.svg"
							alt=""
						/>
						Drag & Drop or to Upload
					</h2>

					<span class="d-flex align-items-center pointer">
						<span class="cin-blue-txt">or Browse</span></span
					>

					<span class="ab-input-icon-heading text-left ml-2">
						<p class="ab-input-icon-subheading">PNG, JPG</p>
					</span>
				</template>
				<b-form-file :accept="fileTypes" @input="uploadFile"> </b-form-file>
			</div>
		</template>
	</b-card>
</template>

<script>
import selectFile from "@/mixins/selectFile";
export default {
	mixins: [selectFile],
	name: "FileInput",
	props: {
		loaderHeight: {
			type: String,
			default: "200px",
		},
		showLoader: {
			type: Boolean,
			default: false,
		},
		text: {
			type: String,
			default: "",
		},
		description: {
			type: Boolean,
			default: false,
		},
		videoDescription: {
			type: Boolean,
			default: false,
		},
		previewVideoDescription: {
			type: Boolean,
			default: false,
		},
		isMandatory: {
			type: Boolean,
			default: false,
		},
		error: {
			type: Boolean,
			default: false,
		},
		showAssetIcon: {
			type: Boolean,
		},
	},
	methods: {
		handleFileDrop(event) {
			const files = event.dataTransfer.files;
			if (files.length > 0) {
				this.uploadFile({ target: { files } });
			}
		},
		openAssetsLibrary() {
			console.log("Open Assets Library");
		},
	},
};
</script>

<style>
.upload-image-container .custom-file {
	position: absolute;
	display: inline-block;
	width: 100%;
	height: calc(1.5em + 0.75rem + 2px);
	margin-bottom: 0;
	height: 100%;
	top: 0;
	opacity: 0;
}
.upload-image-container {
	margin-top: 1.25rem;
}

.cin-blue-txt {
	font-family: "Lato", sans-serif;
	font-size: var(--size-15);
	font-weight: var(--weight-600);
	color: var(--primary-blue);
}

.cin-grey-txt {
	font-family: "Lato", sans-serif;
	font-size: var(--size-10);
	font-weight: var(--weight-500);
	color: #7a7a7a;
}

input[type="file"] {
	width: 100%;
	height: 100%;
	display: block;
	opacity: 0;
	position: absolute;
	top: -1px;
	background-color: white;
	left: 0px;
	/* padding: 2px; */
	cursor: pointer;
}
</style>
